<template>
  <NavigationLayout navigationTitle="ギフトコード交換履歴">
    <div id="gift_card_histories__wrapper" slot="contents">
      <section v-if="!loading">
        <div id="gift_card_histories__container">
          <section
            id="gift_card_histories__header"
            v-if="!hasGiftCardHistories"
          >
            <p>ギフトコードの交換履歴はありません</p>
          </section>
          <section
            v-for="(giftCardHistory, index) in giftCardHistories"
            :key="index"
          >
            <ListItem
              title="交換日"
              v-bind:actionText="
                formatIssueDate(giftCardHistory.giftCardIssueTime)
              "
            />
            <ListItem
              title="交換したギフト"
              v-bind:actionText="giftCardHistory.giftCardName"
            />
            <a :href="giftCardHistory.giftCardUrl" target="_blank">
              <ListItem
                title="URL"
                v-bind:actionText="giftCardHistory.giftCardUrl"
              />
            </a>
          </section>
          <div>
            <div v-bind:style="CautionsStyle">
              <p>
                ＊本プログラムはREALITY株式会社による提供です。
                <br />
                本プログラムについてのお問い合わせは Amazon
                ではお受けしておりません。
                <br />
              </p>

              <p>
                ＊Amazon、Amazon.co.jp およびそれらのロゴは Amazon.com,
                Inc.またはその関連会社の商標です。
              </p>
              <p>
                REALITY
                <a
                  href="https://help.le.wrightflyer.net/?action=inquiry_form&app_id=258305124483241"
                >
                  お問い合わせ窓口
                </a>
                よりお願いいたします。
              </p>
              <div id="caution_google">
                <p>＊Google Playは、Google LLC の商標です。</p>
              </div>
              <p>＊© 2020 iTunes K.K All rights reserved.</p>
            </div>
          </div>
          <GiftCardDialog />
        </div>
      </section>
      <section v-if="loading">
        <div id="gift_card_histories_loading__container">Now Loading...</div>
      </section>
    </div>
  </NavigationLayout>
</template>

<script>
import API from '@/utils/API'
import NavigationLayout from '@/components/NavigationLayout'
import ListItem from '@/components/ListItem'
import ListSubheader from '@/components/ListSubheader'
import MypageStyle from '@/styles/mypage'
import { mapActions } from 'vuex'
import GiftCardDialog from '@/components/GiftCardDialog'
export default {
  components: {
    NavigationLayout,
    ListItem,
    GiftCardDialog,
  },
  computed: {
    hasGiftCardHistories: function () {
      return this.giftCardHistories.length > 0
    },
  },
  data: function () {
    return {
      loading: true,
      giftCardHistories: {},
      CautionsStyle: MypageStyle.Cautions,
      ListItemStyleSectionLast: MypageStyle.ListItemSectionLast,
    }
  },
  methods: {
    ...mapActions('components/giftCardDialog', ['showGiftCardApiErrorDialog']),
    fetchGiftCardHistory: async function () {
      try {
        const request = API.Request.giftCardHistoryGet()
        const response = await API.load(request)
        if (response.histories) {
          this.giftCardHistories = response.histories
        }
      } catch {
        this.showGiftCardApiErrorDialog()
      }
      this.loading = false
    },
    formatIssueDate: function (issueDate) {
      return new Date(issueDate).toLocaleString()
    },
  },
  mounted() {
    this.fetchGiftCardHistory()
  },
}
</script>

<style scoped>
#gift_card_histories__wrapper {
  position: relative;
  height: auto;
  min-height: 100%;
  background-color: #fafafa;
}

#gift_card_histories__container {
  font-family: sans-serif;
  font-size: 14px;
  line-height: 1.43;
  color: #262626;
  padding-top: 20px;
  padding-bottom: 49px;
}

#gift_card_histories__header {
  padding: 12px 15px;
  text-align: left;
  background-color: #ffffff;
  line-height: 1.5;
  color: #383838;
}

#gift_card_histories_loading__container {
  text-align: center;
  color: #808080;
  background-color: #ffffff;
  font-size: 12px;
  padding: 12px 15px;
}

#caution_google {
  font-family: Roboto, sans-serif;
}
section {
  margin-top: 20px;
}
</style>
